import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { FaPlane, FaExclamationTriangle, FaTimes, FaSpinner } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import flighthome from "../assets/flighthome.jpg";
import About from "./About";
import Features from "./Features";
import Price from "./Price";
import SpecialOffer from "./SpecialOffer";
import Services from "./Services";
import Testimonials from "./Testimonials";
import Faq from "./Faq";
import { useSelector, useDispatch } from "react-redux";
import { checkUserLogin } from "../redux/reduxThunk/thunkAuthUser/AuthUser";
import PaymentModal from "./PaymentModal";
import LoginModal from "./LoginModal";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/AuthContext";

// Components
import SearchForm from "./FlightSearch/SearchForm";
import FlightResults from "./FlightResults/FlightResults";
import PriceModal from "./Modals/PriceModal";
import PassengerForm from "./PassengerForm/PassengerForm";
import BookingSuccessModal from "./Modals/BookingSuccessModal";
import FeedbackModal from "./Modals/FeedbackModal";
import UpdateStorageModal from "./Modals/UpdateStorageModal";
import { FiRefreshCw } from "react-icons/fi";
// import axios from "axios";

const Homepage2 = () => {
  const { authdata } = useSelector((state) => state.auth);
  console.log(authdata);

  const [checkModelLogin, setCheckModelLogin] = useState(false);

  const isLoggedIn = Boolean(authdata && authdata.token);
  console.log(isLoggedIn);

  const {
    setOpenModel,
    setWaiting,
    waiting,
    setAddBothOnwardAndReturn,
    setReturnRefId,
    addBothOnwardAndReturn,
    returnRefId,
    onwardRefID,
    setOnwardRefID,
    setUser,
  } = useAuth();

  const [userWallet, setUserWallet] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const url = import.meta.env.VITE_URL;

  useEffect(() => {
    // Homepage2.jsx में:
    const fetchUserWallet = async () => {
      try {
        // ✅ User के लिए सही endpoint
        const response = await axios.get(`${API_BASE}/api/wallet/my-balance`, {
          withCredentials: true,
        });

        console.log("Wallet API Response:", response.data);

        if (response.data.success) {
          const walletData = response.data.data;

          // Check if wallet exists
          if (walletData && walletData.length > 0) {
            const wallet = walletData[0];
            setUserWallet({
              status: "active", // ये confirm करें कि wallet active है
              balance: wallet.total || 0,
              walletId: wallet._id,
              isActive: true,
            });
          } else {
            // No wallet found - wallet not activated
            setUserWallet({
              status: "not_activated",
              balance: 0,
              isActive: false,
            });
          }
        } else {
          // API success false
          setUserWallet({
            status: "error",
            balance: 0,
            isActive: false,
            message: response.data.message || "Failed to load wallet",
          });
        }
      } catch (error) {
        console.error("Error fetching wallet:", error);
        setUserWallet({
          status: "error",
          balance: 0,
          isActive: false,
          message: "Failed to load wallet information",
        });
      }
    };

    fetchUserWallet();
  }, [url, isLoggedIn, checkModelLogin]);

  const ref = useRef(1);

  const [onwardData, setOnwardData] = useState([]);
  const [returnData, setReturnData] = useState([]);

  const API_BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2;

  const [airports, setAirports] = useState([]);

  const [filteredFromAirports, setFilteredFromAirports] = useState([]);
  const [filteredToAirports, setFilteredToAirports] = useState([]);

  // Add loading states for airport search
  const [isLoadingFromAirports, setIsLoadingFromAirports] = useState(false);
  const [isLoadingToAirports, setIsLoadingToAirports] = useState(false);

  // ✅ Validation Setup
  const today = new Date();
  const sixtyDaysAgo = new Date(today);
  sixtyDaysAgo.setDate(today.getDate() - 60);
  const twelveYearsAgo = new Date(today);
  twelveYearsAgo.setFullYear(today.getFullYear() - 12);

  const formSchema = z.object({
    mobile: z
      .string()
      .min(1, "Mobile number is required")
      .regex(/^[6-9]\d{9}$/, "Enter a valid 10-digit Indian mobile number"),
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter a valid email address"),
    passengers: z
      .array(
        z.object({
          title: z.string().min(1, "Title required"),
          gender: z.string().min(1, "Gender required"),
          fName: z
            .string()
            .min(1, "First name required")
            .regex(/^[A-Za-z\s]+$/, "Only alphabets allowed"),
          lName: z
            .string()
            .min(1, "Last name required")
            .regex(/^[A-Za-z\s]+$/, "Only alphabets allowed"),
          dob: z
            .string()
            .min(1, "Date of Birth is required")
            .refine((value) => {
              if (!value) return false;
              const dobDate = new Date(value);
              return !isNaN(dobDate.getTime());
            }, "Enter valid DOB"),
          ppNo: z.string().optional(),
          ppIss: z.string().optional(),
          ppExp: z.string().optional(),
          ppNat: z.string().optional(),
        })
      )
      .min(1, "At least one passenger required"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  // API Configuration
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [tripType, setTripType] = useState(0);
  const [statusRefdId, setStatusRefdId] = useState(null);
  const [statusDatas, setStatusDatas] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Refetch wallet when payment summary modal opens – ensure fresh balance before pay
  useEffect(() => {
    if (!isOpen || !isLoggedIn) return;
    const refetch = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/wallet/my-balance`, { withCredentials: true });
        if (res.data?.success && res.data?.data?.length > 0) {
          const w = res.data.data[0];
          setUserWallet({ status: "active", balance: w.total || 0, walletId: w._id, isActive: true });
        } else {
          setUserWallet((prev) => (typeof prev === "object" ? { ...prev, balance: 0 } : 0));
        }
      } catch (_) { }
    };
    refetch();
  }, [isOpen, isLoggedIn, API_BASE]);

  void motion;

  const [formData, setFormData] = useState({
    class: "Economy",
    from: "",
    to: "",
    departure: "",
    returnDate: "",
    tripType: tripType,
    adults: 1,
    children: 0,
    infants: 0,
    serType: 1,
    cabin: "E",
    fareType: "A",
  });

  const [dropdowns, setDropdowns] = useState({
    class: false,
    from: false,
    to: false,
    travellers: false,
    service: false,
    fare: false,
  });

  // API Integration States
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState({
    onward: [],
    return: [],
  });
  const [combinedResults, setCombinedResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const pagedResults = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return combinedResults.slice(start, start + pageSize);
  }, [combinedResults, currentPage]);

  const totalPages = useMemo(
    () => Math.ceil(combinedResults.length / pageSize) || 1,
    [combinedResults.length]
  );

  const [error, setError] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [debugInfo, setDebugInfo] = useState("");
  const [isBooking, setIsBooking] = useState(false);
  const [isPaying, setIsPaying] = useState(false);

  useEffect(() => {
    if (isBooking) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isBooking]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingFareForAuth, setPendingFareForAuth] = useState(null);
  const [amount, setAmount] = useState(null);
  const [priceSummary, setPriceSummary] = useState(null);
  const totalPayableAmount = useMemo(() => {
    return Number(amount || 0);
  }, [amount]);

  const [bookingError, setBookingError] = useState(null);
  const [bookingResult, setBookingResult] = useState(null);
  const [lastSearchPayload, setLastSearchPayload] = useState(null);

  // Price verification modal states
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedFlightForPrice, setSelectedFlightForPrice] = useState(null);
  const [priceOptions, setPriceOptions] = useState([]);
  const [isLoadingPrices, setIsLoadingPrices] = useState(false);
  const [selectedFare, setSelectedFare] = useState(null);
  const [validationRequirements, setValidationRequirements] = useState({
    doc_mandatory: 0,
    pan_mandatory: 0,
    document_type: 0,
  });
  const [showPassengerForm, setShowPassengerForm] = useState(false);
  const [webCheckinSelected, setWebCheckinSelected] = useState(false);
  const [passengerDetails, setPassengerDetails] = useState([]);
  const [formPassengerData, setFormPassengerData] = useState([
    {
      title: "",
      fName: "",
      lName: "",
      pType: "",
      gender: "",
      dob: "",
      ppNo: "",
      ppIss: "",
      ppExp: "",
      ppNat: "",
    },
  ]);
  const [contactInfo, setContactInfo] = useState({
    mobile: "",
    email: "",
  });
  const [gstInfo, setGstInfo] = useState({ gstNo: "", companyName: "", address: "" });
  const [ssrOptions, setSsrOptions] = useState({});
  const [selectedSsr, setSelectedSsr] = useState({});
  const [isLoadingSsr, setIsLoadingSsr] = useState(false);
  const [selectedBaggagePerPax, setSelectedBaggagePerPax] = useState([]);
  const [selectedMealPerPax, setSelectedMealPerPax] = useState([]);
  const [ssrItems, setSsrItems] = useState({ onward: {}, return: {} });
  const [expandedFlights, setExpandedFlights] = useState({});
  const [availableSeats, setAvailableSeats] = useState([]);
  const [isLoadingSeats, setIsLoadingSeats] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState({});
  const [showBookingSuccess, setShowBookingSuccess] = useState(false);
  const [bookingSuccessData, setBookingSuccessData] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedbackText, setFeedbackText] = useState("");
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // Sorting and filtering states
  const [sortBy, setSortBy] = useState("cheapest");
  const [filterStops, setFilterStops] = useState("all");

  // Seat Selection Visibility
  const [showSeatSelection, setShowSeatSelection] = useState(false);

  ///////////////////// btn disable
  const [isWalletProcessing, setIsWalletProcessing] = useState(false);

  // Mark unused variables to satisfy linter
  void setSelectedFlight;
  void setPassengerDetails;
  void ssrOptions;
  void isLoadingSsr;

  // Dropdown Data States - Now using airports from database
  const [isLoadingLocations, setIsLoadingLocations] = useState(false);

  // Pre-filter airports by service type for better performance (India/IN/IND or contains "india" = domestic)
  const airportsByServiceType = useMemo(() => {
    if (airports.length === 0) return { domestic: [], international: [] };
    const isIndia = (c) => {
      if (!c || typeof c !== "string") return false;
      const t = String(c).trim().toLowerCase();
      return t === "india" || t === "in" || t === "ind" || t.includes("india");
    };
    const domestic = airports.filter((airport) => isIndia(airport.country));
    const international = airports.filter(
      (airport) => !isIndia(airport.country)
    );
    return { domestic, international };
  }, [airports]);

  // ✅ Debounced search functions
  const debouncedSearchFromAirports = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        setFilteredFromAirports([]);
        setIsLoadingFromAirports(false);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: false,
        }));
        return;
      }

      try {
        setIsLoadingFromAirports(true);
        const response = await axios.get(
          `${API_BASE}/api/debouce/search?q=${encodeURIComponent(searchTerm)}`
        );

        // Transform the API response to match your expected format
        const transformedAirports = response.data.map((airport) => ({
          code: airport.airportcode,
          name: airport.airportname,
          city: airport.airportcity,
          country: airport.airportcountry,
          airport: airport.airportname,
        }));

        setFilteredFromAirports(transformedAirports);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: transformedAirports.length > 0,
        }));
      } catch (error) {
        console.error("Error searching from airports:", error);
        setFilteredFromAirports([]);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: false,
        }));
      } finally {
        setIsLoadingFromAirports(false);
      }
    }, 250), // 250ms debounce for responsive search-as-you-type
    [API_BASE]
  );

  const debouncedSearchToAirports = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        setFilteredToAirports([]);
        setIsLoadingToAirports(false);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: false,
        }));
        return;
      }

      try {
        setIsLoadingToAirports(true);
        const response = await axios.get(
          `${API_BASE}/api/debouce/search?q=${encodeURIComponent(searchTerm)}`
        );

        // Transform the API response to match your expected format
        const transformedAirports = response.data.map((airport) => ({
          code: airport.airportcode,
          name: airport.airportname,
          city: airport.airportcity,
          country: airport.airportcountry,
          airport: airport.airportname,
        }));

        setFilteredToAirports(transformedAirports);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: transformedAirports.length > 0,
        }));
      } catch (error) {
        console.error("Error searching to airports:", error);
        setFilteredToAirports([]);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: false,
        }));
      } finally {
        setIsLoadingToAirports(false);
      }
    }, 250), // 250ms debounce for responsive search-as-you-type
    [API_BASE]
  );

  // ✅ Improved From input change handler with debounce
  const handleFromInputChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      from: value,
    }));

    // Clear previous results if search term is too short
    if (!value || value.trim().length < 2) {
      setFilteredFromAirports([]);
      setDropdowns((prevDropdowns) => ({
        ...prevDropdowns,
        from: false,
      }));
      return;
    }

    // Show loading state
    setIsLoadingFromAirports(true);
    setDropdowns((prevDropdowns) => ({
      ...prevDropdowns,
      from: true,
    }));

    // Trigger debounced search
    debouncedSearchFromAirports(value);
  };

  // ✅ Improved To input change handler with debounce
  const handleToInputChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      to: value,
    }));

    // Clear previous results if search term is too short
    if (!value || value.trim().length < 2) {
      setFilteredToAirports([]);
      setDropdowns((prevDropdowns) => ({
        ...prevDropdowns,
        to: false,
      }));
      return;
    }

    // Show loading state
    setIsLoadingToAirports(true);
    setDropdowns((prevDropdowns) => ({
      ...prevDropdowns,
      to: true,
    }));

    // Trigger debounced search
    debouncedSearchToAirports(value);
  };

  // Clear From/To on focus so user can type a fresh search (professional UX: click field = new search)
  const handleFromFocus = useCallback(() => {
    setFormData((prev) => ({ ...prev, from: "" }));
    setFilteredFromAirports([]);
    setDropdowns((prev) => ({ ...prev, from: true }));
  }, [setFormData, setDropdowns]);
  const handleToFocus = useCallback(() => {
    setFormData((prev) => ({ ...prev, to: "" }));
    setFilteredToAirports([]);
    setDropdowns((prev) => ({ ...prev, to: true }));
  }, [setFormData, setDropdowns]);

  // Cleanup debounce functions on unmount
  useEffect(() => {
    return () => {
      debouncedSearchFromAirports.cancel();
      debouncedSearchToAirports.cancel();
    };
  }, [debouncedSearchFromAirports, debouncedSearchToAirports]);

  // Load locations on component mount
  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    dispatch(checkUserLogin());
  }, [dispatch]);

  // Check if stored date/time has been reached and show update modal
  useEffect(() => {
    const checkUpdateDate = () => {
      const storedDate = localStorage.getItem("flightSearchUpdateDate");
      if (storedDate) {
        const updateDate = new Date(storedDate);
        const now = new Date();

        if (now >= updateDate) {
          setShowUpdateModal(true);
        }
      }
    };

    checkUpdateDate();
    const interval = setInterval(checkUpdateDate, 60000);
    return () => clearInterval(interval);
  }, []);

  // Log debug info in development
  useEffect(() => {
    if (
      typeof import.meta !== "undefined" &&
      import.meta.env?.MODE === "development" &&
      debugInfo
    ) {
      console.debug("Flight debug:", debugInfo);
    }
  }, [debugInfo]);

  // Root refs for all dropdowns
  const travellersRef = useRef(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const serviceRef = useRef(null);
  const fareRef = useRef(null);

  // Dropdown/outside click logic for all dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdowns.travellers &&
        travellersRef.current &&
        !travellersRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, travellers: false }));
      }
      if (
        dropdowns.from &&
        fromRef.current &&
        !fromRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, from: false }));
      }
      if (
        dropdowns.to &&
        toRef.current &&
        !toRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, to: false }));
      }
      if (
        dropdowns.service &&
        serviceRef.current &&
        !serviceRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, service: false }));
      }
      if (
        dropdowns.fare &&
        fareRef.current &&
        !fareRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, fare: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdowns]);

  // Add this useEffect to properly merge data
  useEffect(() => {
    if (onwardData.length > 0 && returnData.length > 0) {
      // Make sure both are arrays before merging
      const onwardArray = Array.isArray(onwardData) ? onwardData : [onwardData];
      const returnArray = Array.isArray(returnData) ? returnData : [returnData];

      setAddBothOnwardAndReturn([...onwardArray, ...returnArray]);
    }
  }, [onwardData, returnData]); // This runs whenever onwardData or returnData changes

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRefresh = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/removecookies`, {
        withCredentials: true, // because cookies
      });

      if (res.data.success === true) {
        // Clear localStorage
        localStorage.clear();

        // Optional: reload page
        window.location.reload();
      }
    } catch (error) {
      console.error("Error removing cookies", error);
    }
  };

  const fetchLocations = async () => {
    try {
      setIsLoadingLocations(true);
      // Initial airports load if needed
      const response = await fetch(`${API_BASE}/api/airport`, {
        credentials: "include",
      });
      const data = await response.json();
      if (data.success && data.data) {
        const mappedAirports = data.data.map((airport) => ({
          code: airport.airportcode || airport.code,
          name: airport.airportname || airport.name,
          city: airport.airportcity || airport.city,
          country: airport.airportcountry || airport.country,
          airport: airport.airportname || airport.name,
        }));
        setAirports(mappedAirports);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setError("Failed to load locations");
    } finally {
      setIsLoadingLocations(false);
    }
  };

  // Get token from localStorage
  const getTokenFromLocalStorage = () => {
    try {
      const tokenData = localStorage.getItem("flightToken");
      if (!tokenData) {
        setDebugInfo("No token found in localStorage");
        return null;
      }
      return tokenData || null;
    } catch (error) {
      console.error("Error reading token from localStorage:", error);
      setDebugInfo(`LocalStorage token error: ${error.message}`);
      return null;
    }
  };

  // Get flightID, refID and full status from localStorage
  const getFlightDataFromStorage = () => {
    try {
      const flightStatus = localStorage.getItem("flightStatus");
      if (flightStatus) {
        const status = JSON.parse(flightStatus);
        return {
          flightID: status.flightID,
          refID: status.refID,
          status: status,
        };
      }
    } catch (error) {
      console.error("Error parsing flight status from localStorage:", error);
    }
    return {
      flightID: null,
      refID: null,
      status: null,
    };
  };

  const searchFlights = async (searchData) => {
    try {
      setWaiting(true);
      setDebugInfo("Starting flight search...");

      // 1) CHECK TOKEN
      const checkToken = await fetch(`${API_BASE}/api/flight/checkToken`, {
        method: "GET",
        credentials: "include",
      });

      const checkResult = await checkToken.json();

      if (!checkResult.success) {
        setDebugInfo("Token missing → generating new token...");

        // GENERATE TOKEN
        const genToken = await fetch(`${API_BASE}/api/getToken`, {
          method: "GET",
          credentials: "include",
        });

        const tokenResult = await genToken.json();

        if (!tokenResult.success) {
          // Provide more detailed error message
          const errorMessage = tokenResult.message || "Failed to generate flight token";
          const errorDetails = tokenResult.debug ? `\nDetails: ${JSON.stringify(tokenResult.debug, null, 2)}` : "";
          const missingVars = tokenResult.missing ? `\nMissing env vars: ${tokenResult.missing.join(", ")}` : "";

          console.error("Token generation failed:", {
            message: errorMessage,
            details: tokenResult.debug,
            missing: tokenResult.missing,
            fullResponse: tokenResult,
          });

          throw new Error(`${errorMessage}${missingVars}${errorDetails}`);
        }

        setDebugInfo("New token generated successfully");
      } else {
        setDebugInfo("Token verified successfully");
      }

      // 3) CALL SEARCH API
      setDebugInfo("Calling search API...");

      const response = await fetch(`${API_BASE}/api/postSearchFlight`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(searchData),
      });

      if (!response.ok) {
        const errorMsg = await response.text();
        throw new Error(`Search API failed: ${errorMsg}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Search failed");
      }

      // V2 API Response Structure
      const responseData = data.data;

      // DEBUG: Log the full response structure to understand what we're getting
      console.log("🔍 Full API Response Structure:", JSON.stringify(responseData, null, 2));
      console.log("🔍 Response keys:", Object.keys(responseData || {}));
      console.log("🔍 responseData.flights exists:", !!responseData?.flights);
      console.log("🔍 responseData.flights length:", responseData?.flights?.length);
      console.log("🔍 responseData.Results exists:", !!responseData?.Results);
      console.log("🔍 responseData.Results length:", responseData?.Results?.length);
      console.log("🔍 responseData.results exists:", !!responseData?.results);
      console.log("🔍 responseData.results length:", responseData?.results?.length);
      console.log("🔍 responseData.data exists:", !!responseData?.data);
      if (responseData?.data) {
        console.log("🔍 responseData.data keys:", Object.keys(responseData.data));
        console.log("🔍 responseData.data.flights exists:", !!responseData.data.flights);
        console.log("🔍 responseData.data.flights length:", responseData.data.flights?.length);
      }

      // Check for V2 error response
      if (responseData?.code === "error") {
        throw new Error(responseData.error_msg || "Flight search failed");
      }

      // V2: Extract flights from response - check multiple possible locations
      // V2 structure can be: data.flights, data.Results, data.results, or data.data.flights
      let flights = [];

      if (responseData?.flights && Array.isArray(responseData.flights)) {
        flights = responseData.flights;
        console.log("✅ Found flights in responseData.flights:", flights.length);
      } else if (responseData?.Results && Array.isArray(responseData.Results)) {
        flights = responseData.Results;
        console.log("✅ Found flights in responseData.Results:", flights.length);
      } else if (responseData?.results && Array.isArray(responseData.results)) {
        flights = responseData.results;
        console.log("✅ Found flights in responseData.results:", flights.length);
      } else if (responseData?.data?.flights && Array.isArray(responseData.data.flights)) {
        flights = responseData.data.flights;
        console.log("✅ Found flights in responseData.data.flights:", flights.length);
      } else if (responseData?.data?.Results && Array.isArray(responseData.data.Results)) {
        flights = responseData.data.Results;
        console.log("✅ Found flights in responseData.data.Results:", flights.length);
      } else if (responseData?.data?.results && Array.isArray(responseData.data.results)) {
        flights = responseData.data.results;
        console.log("✅ Found flights in responseData.data.results:", flights.length);
      } else {
        // Try to find any array in the response
        console.warn("⚠️ No flights array found in expected locations. Searching entire response...");
        const searchForFlights = (obj, depth = 0) => {
          if (depth > 3) return null; // Limit recursion
          if (Array.isArray(obj) && obj.length > 0) {
            // Check if it looks like a flights array
            if (obj[0]?.flightID || obj[0]?.Flights || obj[0]?.Fare) {
              return obj;
            }
          }
          if (typeof obj === 'object' && obj !== null) {
            for (const key in obj) {
              const result = searchForFlights(obj[key], depth + 1);
              if (result) return result;
            }
          }
          return null;
        };
        const foundFlights = searchForFlights(responseData);
        if (foundFlights) {
          flights = foundFlights;
          console.log("✅ Found flights by searching response:", flights.length);
        } else {
          console.error("❌ Could not find flights array in response");
        }
      }

      const refID = responseData?.status?.refID || responseData?.Status?.refID || responseData?.data?.status?.refID || responseData?.data?.Status?.refID;

      if (flights.length === 0) {
        alert("No flights available for the selected criteria.");
        setDebugInfo("No flights found");
        return { ...responseData, results: [], flights: [] };
      }

      // V2: Process flights to normalize structure
      const processedFlights = flights.map((flight) => {
        // V2: flightID is now string, not integer
        // V2: Enhanced fare information
        const fare = flight.Fare || flight.fare || {};

        return {
          ...flight,
          _fareLoaded: false,
          _fareOptions: null,
          flightID: String(flight.flightID || flight.flightId || ""), // V2: String
          Fare: {
            ...fare,
            // V2: New fare fields
            fareTypeInd: fare.fareTypeInd,
            fareTypeDesc: fare.fareTypeDesc,
            popMsg: fare.popMsg,
            refundType: fare.refundType,
            validation: fare.validation || {},
            // V2: Enhanced baggage info
            bagCkin: fare.bagCkin || flight.bagCkin,
            bagCbin: fare.bagCbin || flight.bagCbin,
            // V2: Return object for round trips
            Return: fare.Return,
          },
          // V2: Terminal information
          depTer: flight.depTer,
          arrTer: flight.arrTer,
          // V2: Operating airline
          airCodeOp: flight.airCodeOp,
          airNameOp: flight.airNameOp,
        };
      });

      // Domestic round trip: two searches → set onwardRefID then returnRefId. Same for international round trip (2-search mode).
      if (searchData?.serType == 1 || (searchData?.serType == 2 && (ref.current === 1 || ref.current === 2))) {
        if (ref.current === 1) {
          setOnwardData({ ...data, data: { ...responseData, flights: processedFlights } });
          setOnwardRefID(refID || "");
          ref.current = 2;
        } else if (ref.current === 2) {
          setReturnData({ ...data, data: { ...responseData, flights: processedFlights } });
          setReturnRefId(refID || "");
        }
      }

      setDebugInfo("Flight search success");
      setStatusDatas(refID);
      setOpenModel(true);

      // Return normalized response
      return {
        ...responseData,
        Status: { refID },
        status: { refID },
        results: processedFlights,
        flights: processedFlights,
        Results: processedFlights,
      };
    } catch (error) {
      console.error("Search Flights Error:", error.message);
      setDebugInfo(error.message);
      throw error;
    } finally {
      setWaiting(false);
    }
  };

  // V2: Fetch all fare types for a flight (NEW endpoint)
  const fetchFareDetails = async (flightId, refId) => {
    try {
      const response = await fetch(`${API_BASE}/api/postFareDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          flightID: flightId,
          refID: refId,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        console.warn("Fare details fetch failed, using search results:", data.message);
        return null; // Fallback to search results
      }

      // V2: postFareDetails returns { results: [...], Status: {...} }
      // Each result in results array is a different fare type
      return data.data; // Returns all fare types for the flight
    } catch (error) {
      console.error("Error fetching fare details:", error);
      return null; // Fallback to search results
    }
  };

  // V2: Fetch SSR options (Bagg, Meal) – uses postFareDetails (safe; postPriceVerify is single-use at book time)
  const fetchSSROptions = async (flightId, refId, isRoundTrip = false, fareType = null) => {
    try {
      const fareDetailsData = await fetchFareDetails(flightId, refId);
      if (!fareDetailsData?.results?.length) {
        return { ssrInfo: {}, validationRequirements: { doc_mandatory: 0, pan_mandatory: 0, document_type: 0 }, bookingRefID: refId };
      }
      // Extract Bagg/Meal from first fare result – FTD may have them in Flights, Onward[0], ssrInfo, or top-level
      const first = fareDetailsData.results[0];
      const flights = first?.Flights || {};
      const onward = flights?.Onward;
      const seg0 = Array.isArray(onward) ? onward[0] : onward;
      const ssr = first?.ssrInfo || flights?.ssrInfo || {};
      const bagg = flights?.Bagg || seg0?.Bagg || first?.Bagg || ssr?.Onward?.Bagg || ssr?.Bagg || [];
      const meal = flights?.Meal || seg0?.Meal || first?.Meal || ssr?.Onward?.Meal || ssr?.Meal || [];
      const ssrOnward = (Array.isArray(bagg) && bagg.length > 0) || (Array.isArray(meal) && meal.length > 0)
        ? { Bagg: Array.isArray(bagg) ? bagg : [], Meal: Array.isArray(meal) ? meal : [] }
        : {};
      const ssrInfo = Object.keys(ssrOnward).length > 0 ? { Onward: ssrOnward } : {};
      return {
        ssrInfo,
        validationRequirements: first?.Validation || { doc_mandatory: 0, pan_mandatory: 0, document_type: 0 },
        bookingRefID: fareDetailsData?.Status?.refID || refId,
      };
    } catch (e) {
      console.warn("fetchSSROptions failed, using empty:", e.message);
      return { ssrInfo: {}, validationRequirements: { doc_mandatory: 0, pan_mandatory: 0, document_type: 0 }, bookingRefID: refId };
    }
  };

  // Price Verification API - V2 Enhanced
  // V2 Flow: Get all fare types from postFareDetails – call ONCE per flight expand, cache on flight._fareOptions
  const verifyFlightPrice = async (flightId, refId, isRoundTrip = false, flight = null) => {
    try {
      // FTD V2: Return cached fares – postFareDetails must be called exactly once per flight card expand
      if (flight && flight._fareLoaded && flight._fareOptions && Array.isArray(flight._fareOptions) && flight._fareOptions.length > 0) {
        console.log("🔍 [FARE CACHE HIT] Using cached fares for flightID:", flightId);
        if (isRoundTrip) return { fareOptions: flight._fareOptions, onwardRefID: refId, returnRefID: refId };
        return flight._fareOptions;
      }

      setIsLoadingPrices(true);

      // STEP 1: Get ALL fare types using postFareDetails (V2) – only when not cached
      console.log("🔍 Step 1: Fetching all fare types from postFareDetails (first expand)...");
      const fareDetailsData = await fetchFareDetails(flightId, refId);

      let fareOptions = [];

      if (fareDetailsData && fareDetailsData.results && Array.isArray(fareDetailsData.results) && fareDetailsData.results.length > 0) {
        // V2: postFareDetails returns multiple fare types in results array
        console.log("✅ Got fare details - fare types:", fareDetailsData.results.length);
        console.log("🔍 Fare Details Response:", JSON.stringify(fareDetailsData, null, 2));

        // V2: Get refID from Status node in fareDetailsData
        const fareDetailsRefID = fareDetailsData?.Status?.refID || refId;

        // V2: ONLY use actual fare types from postFareDetails - DO NOT create fake fare options from SSR
        fareOptions = fareDetailsData.results.map((fareResult, index) => {
          const fare = fareResult.Fare || {};
          const flights = fareResult.Flights || {};
          const validation = fareResult.Validation || {};

          // FTD: Each fare has NEW flightID from postFareDetails (e.g. 135236) – NOT search flightID (135234)
          // Path per FTD doc: results[i].Flights.Onward[0].flightID
          const onwardData = flights?.Onward;
          const firstSegment = Array.isArray(onwardData)
            ? onwardData[0]
            : onwardData && typeof onwardData === "object"
              ? onwardData
              : null;
          const fareSpecificFlightID =
            firstSegment?.flightID ??
            flights?.Onward?.[0]?.flightID ??
            fare?.flightID ??
            fareResult?.flightID ??
            fareResult?.flightId ??
            null;
          if (!fareSpecificFlightID) {
            console.error("Fare missing flightID:", fareResult);
            throw new Error(`Fare option ${index + 1} missing flightID – cannot use search flightID`);
          }
          // Never use search flightId – fare flightID must be different for bookable fares
          if (String(fareSpecificFlightID) === String(flightId)) {
            console.warn(
              `[FTD] Fare ${index + 1} has same flightID as search (${flightId}) – may be wrong. Check postFareDetails response structure.`
            );
          }

          // Extract SSR (Bagg, Meal) from fareDetails – FTD may have in Flights, Onward[0], or top-level
          const bagg = flights?.Bagg || firstSegment?.Bagg || fareResult?.Bagg || [];
          const meal = flights?.Meal || firstSegment?.Meal || fareResult?.Meal || [];
          const baggageOptions = Array.isArray(bagg) ? bagg : [];
          const mealOptions = Array.isArray(meal) ? meal : [];
          const ssrInfo = (baggageOptions.length > 0 || mealOptions.length > 0)
            ? { Onward: { Bagg: baggageOptions, Meal: mealOptions } }
            : null;

          // Parse baggage strings (remove || separator)
          const bagCkin = (fare.bagCkin || flights.bagCkin || "").replace(/\|\|/g, "").trim();
          const bagCbin = (fare.bagCbin || flights.bagCbin || "").replace(/\|\|/g, "").trim();

          return {
            fareName: fare.fareTypeDesc || `Fare ${index + 1}`,
            price: parseInt(fare.total?.total || 0),
            base: parseInt(fare.total?.base || 0),
            tax: parseInt(fare.total?.tax || 0),
            netfare: parseInt(fare.total?.netfare || 0),
            bagCkin: bagCkin,
            bagCbin: bagCbin,
            seats: fare.seats || "N/A",
            fareTypeInd: fare.fareTypeInd,
            fareTypeDesc: fare.fareTypeDesc,
            popMsg: fare.popMsg,
            refundType: fare.refundType || "P",
            refundable: fare.refundType === "P" ? "Partially Refundable" : "Non-Refundable",
            cancelChgAir: fare.cancelChgAir,
            cancelChgFTD: fare.cancelChgFTD,
            baggage: {
              cabin: bagCbin,
              checkin: bagCkin,
            },
            validation: validation,
            flightData: fareResult,
            // V2: Use fare-specific flightID and refID from fareDetails response
            flightID: fareSpecificFlightID, // Each fare has its own flightID
            refID: fareDetailsRefID, // refID from Status node in postFareDetails response
            isFromFareDetails: true,
            index: index,
            ssrInfo,
            baggageOptions,
            mealOptions,
          };
        });
      } else {
        // postFareDetails failed – no postPriceVerify fallback (FTD single-use lock)
        console.warn("⚠️ postFareDetails failed – no fare options from API");
      }

      // FTD: Never create default with search flightID – it cannot be booked
      if (fareOptions.length === 0) {
        console.error("❌ No fare options from postFareDetails – cannot book without fare-specific flightID");
        throw new Error("No fare options available. Please try again or search for a different flight.");
      }

      console.log("✅ Total fare types from postFareDetails:", fareOptions.length);
      console.log("✅ Fare types breakdown:", fareOptions.map(f => ({
        name: f.fareName,
        fareTypeInd: f.fareTypeInd,
        fareTypeDesc: f.fareTypeDesc,
        price: f.price,
      })));

      // V2: CRITICAL - Only return actual fare types from postFareDetails
      // DO NOT create fake fare options from SSR options
      // SSR options should be shown as add-ons AFTER user selects a fare, not as separate fare options
      if (fareOptions.length === 0) {
        console.error("❌ ERROR: No fare options from postFareDetails!");
      } else {
        console.log("✅ V2: Returning ONLY actual fare types from postFareDetails. SSR options will be fetched separately when user selects a fare.");
      }

      // Store fare options (without SSR - SSR will be fetched when user selects a fare)
      setPriceOptions(fareOptions);

      // FTD V2: Cache fares on flight object – prevents duplicate postFareDetails on re-expand
      if (flight && fareOptions.length > 0) {
        flight._fareLoaded = true;
        flight._fareOptions = fareOptions;
        console.log("🔍 [FARE CACHE WRITE] Cached", fareOptions.length, "fares for flightID:", flightId);
      }

      // Set default validation requirements (will be updated when SSR is fetched)
      setValidationRequirements({
        doc_mandatory: 0,
        pan_mandatory: 0,
        document_type: 0,
      });

      // Round trip: use refId from search – do NOT call postPriceVerify (backend does it at book time)
      if (isRoundTrip) {
        return { fareOptions, onwardRefID: refId, returnRefID: refId };
      }

      return fareOptions;
    } catch (error) {
      console.error("Price verification error:", error);
      setError(error.message);
      setPriceOptions([]);
      throw error;
    } finally {
      setIsLoadingPrices(false);
    }
  };

  // Seat Selection API
  const selectSeats = async (flightId, refId) => {
    try {
      setIsLoadingSsr(true);

      const response = await fetch(`${API_BASE}/api/selectSeats`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          flightID: flightId,
          refID: refId,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Seat selection failed");
      }

      setSsrOptions(data.data || {});
      return data.data;
    } catch (error) {
      console.error("Seat selection error:", error);
      setError(error.message);
      throw error;
    } finally {
      setIsLoadingSsr(false);
    }
  };

  // Generate simplified passenger details for seat selection
  const generateSeatPassengerDetails = () => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const passenger = [];

    // If no passenger are configured, return at least one default passenger
    if (totalpassenger === 0) {
      return [
        {
          title: "Mr",
          fName: "Test",
          lName: "User",
          pType: "A",
          gender: "M",
          dob: "1990-01-01"
        },
      ];
    }

    for (let i = 0; i < totalpassenger; i++) {
      const passengerData = formPassengerData[i] || {};
      const passengerType =
        i < formData.adults
          ? "A"
          : i < formData.adults + formData.children
            ? "C"
            : "I";

      passenger.push({
        title: passengerData.title || "Mr",
        fName: passengerData.fName || passengerData.firstName || "Test",
        lName: passengerData.lName || passengerData.lastName || "User",
        gender: passengerData.gender || "M",
        dob: passengerData.dob || "1990-01-01",
        pType: passengerType,
      });
    }

    return passenger;
  };

  // Fetch available seats
  const fetchSeats = async (flightId, refId) => {
    try {
      setIsLoadingSeats(true);

      // Generate simplified passenger details for seat selection
      const passengerDetails = generateSeatPassengerDetails();

      const response = await fetch(`${API_BASE}/api/seats`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          flightID: Number(flightId),
          refID: refId,
          passenger: passengerDetails,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Seat fetching failed");
      }

      // Extract seat map from the API response
      const seatMap = data.data?.FlightSeat?.Onward?.[0]?.SeatMap || [];

      setAvailableSeats(seatMap);
      return seatMap;
    } catch (error) {
      console.error("Error fetching seats:", error);
      setAvailableSeats([]);
      throw error;
    } finally {
      setIsLoadingSeats(false);
    }
  };

  void selectSeats;

  // Booking with SSR API
  const bookFlightWithSSR = async (
    flight,
    passenger,
    searchPayload,
    dataforWallet,
    amount
  ) => {
    try {
      setIsBooking(true);
      setBookingError(null);
      setBookingResult(null);

      const clientId = generateClientID();

      const passengerData = generatePassengerDetails();

      // FTD: MUST use fare refID + fare flightID (from postFareDetails)
      const onwardFareRefID =
        flight?.fareRefID ||
        flight?.selectedOnwardFare?.refID ||
        flight?.selectedOnwardFare?.bookingRefID ||
        flight?.selectedFare?.refID ||
        flight?.selectedFare?.bookingRefID ||
        flight?.refID;
      const returnFareRefID =
        flight?.selectedReturnFare?.refID ||
        flight?.selectedReturnFare?.bookingRefID;
      const onwardRefIDToSend = onwardFareRefID || flight?.onwardRefID || onwardRefID;
      const returnRefIdToSend = returnFareRefID || flight?.returnRefId || statusDatas;

      // FTD V2: ONLY fareDetails fare.flightID is bookable – no search flightID fallback
      const fareFlightIDSSR = flight?.selectedFare?.flightID;
      if (!fareFlightIDSSR) {
        throw new Error("Fare flightID missing – please select a fare and try again");
      }
      // Explicitly extract what is strictly necessary for FTD + Backend
      // FTD Required Fields: flightID, refID, passenger, clientID, mobile, email, web_checkin, gst
      // Backend Required Fields: depCity, arrCity, onDate, reDate, depCName, arrCName, totalAmount, walletAmount
      const reqBody = {
        // --- Core FTD API Fields ---
        flightID: flight?.isRoundTrip ? (flight?.selectedOnwardFare?.flightID || flight?.selectedFare?.flightID || fareFlightIDSSR) : fareFlightIDSSR,
        returnFlightID: flight?.selectedReturnFare?.flightID,
        refID: onwardFareRefID || returnFareRefID || flight?.refID,
        onwardRefID: onwardRefIDToSend,
        returnRefID: returnRefIdToSend,
        clientID: clientId,
        passenger: passengerData,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        ...(gstInfo?.gstNo && { gstNo: gstInfo.gstNo, companyName: gstInfo.companyName || "", gstAddress: gstInfo.address || "" }),

        // --- Core FTD API Fields for SSR Extractions ---
        // Expose SSR explicitly so backend doesn't need the 'selected' object
        selectedSeats: selectedSeats,
        selectedBaggage: flight?.selectedBaggage || flight?.selectedFare?.baggageOption,
        selectedMeal: flight?.selectedMeal || flight?.selectedFare?.mealOption,
        selectedOnwardBaggage: flight?.selectedOnwardFare?.baggageOption || flight?.selectedOnwardFare?.ssrInfo?.baggageOption,
        selectedOnwardMeal: flight?.selectedOnwardFare?.mealOption || flight?.selectedOnwardFare?.ssrInfo?.mealOption,
        selectedReturnBaggage: flight?.selectedReturnFare?.baggageOption || flight?.selectedReturnFare?.ssrInfo?.baggageOption,
        selectedReturnMeal: flight?.selectedReturnFare?.mealOption || flight?.selectedReturnFare?.ssrInfo?.mealOption,
        selectedBaggagePerPax: selectedBaggagePerPax?.filter(Boolean) || [],
        selectedMealPerPax: selectedMealPerPax?.filter(Boolean) || [],

        // --- Backend Operational Fields ---
        totalAmount: amount || flight.totalPrice || flight?.selectedFare?.price || flight?.selectedFare?.totalPrice || flight?.selectedOnwardFare?.price || flight?.Fare?.total?.total || 0,
        priceSummary: priceSummary,
        ...(dataforWallet === "wallet" && amount != null
          ? { paymentMethod: "wallet", walletAmount: amount }
          : {}),
        tripType: tripType,
        serType: formData.serType,
        isRoundTrip: flight.isRoundTrip || false,
        depCity: searchPayload?.depCity,
        arrCity: searchPayload?.arrCity,
        onDate: searchPayload?.onDate,
        reDate: searchPayload?.reDate,
        depCName: flight?.flight?.Flights?.Onward?.[0]?.depCName || searchPayload?.depCity,
        arrCName: flight?.flight?.Flights?.Onward?.[0]?.arrCName || searchPayload?.arrCity,
      };

      const res = await fetch(`${API_BASE}/api/checkAuth`, {
        credentials: "include",
      });
      const dataAuth = await res.json();

      if (!dataAuth?.success) {
        setShowLoginModal(true);
        return;
      }

      let endpoint = "/api/bookDomesticSingleSSR";
      if (Number(formData.serType) === 1) {
        endpoint = flight.isRoundTrip ? "/api/bookDomesticRoundSSR" : "/api/bookDomesticSingleSSR";
      } else {
        endpoint = flight.isRoundTrip ? "/api/bookIntlRoundSSR" : "/api/bookIntlSingleSSR";
      }

      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          ...reqBody,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (data.duplicate) {
          throw new Error(
            data.message || "Booking already completed with this reference. Please check My Bookings."
          );
        }
        throw new Error(data.message || "Booking with SSR failed");
      }

      const calculatedTotal = flight?.Fare?.total?.total
        ? Number(flight.Fare.total.total) + 300
        : data.data?.totalAmount || 0;

      const bookingId =
        data.data?.Status?.refID ||
        data.data?.Status?.bookingReference ||
        data.data?.bookingReference ||
        data.data?.refID ||
        statusDatas ||
        "N/A";

      // Send booking confirmation email
      const emailResult = await sendBookingConfirmationEmail({
        flightInfo: selectedFlightForPrice,
        passengerDetails: passengerData,
        contactInfo: { mobile: contactInfo.mobile, email: contactInfo.email },
        selectedSeats: selectedSeats,
        totalAmount: calculatedTotal,
        bookingReference: bookingId,
      });

      setBookingResult(data.data);
      setBookingSuccessData({
        ...data.data,
        emailSent: emailResult.success,
        emailMessage: emailResult.message,
      });
      setShowBookingSuccess(true);

      // Wallet is deducted by backend only after booking success (no frontend deduct)

      return data.data;
    } catch (error) {
      setBookingError(error.message);
      throw error;
    } finally {
      setIsBooking(false);
    }
  };

  // Regular Booking API (without SSR)
  const bookSelectedFlight = async (
    flight,
    passenger,
    searchPayload,
    dataforWallet,
    amount
  ) => {
    try {
      setIsBooking(true);
      setBookingError(null);
      setBookingResult(null);

      const clientId = generateClientID();
      const passengerData = generatePassengerDetails();

      // Recalculate webCheckinTotalCost here to add it to payload
      const paxCount = Math.max(1, (formData?.adults || 0) + (formData?.children || 0) + (formData?.infants || 0));
      const onwardSegments = flight?.onwardFlight?.length || flight?.onwardFlight?.Flights?.Onward?.length || 1;
      const returnSegments = flight?.returnFlight?.length || flight?.returnFlight?.Flights?.Onward?.length || 0;
      const numberOfSectors = flight?.isRoundTrip ? (onwardSegments + returnSegments) : onwardSegments;
      const webCheckinUnitCost = flight?.selectedFare?.ssrInfo?.web_checkin_amount || flight?.ssrInfo?.web_checkin_amount || 79;
      const webCheckinTotalCost = paxCount * numberOfSectors * webCheckinUnitCost;

      // FTD: MUST use fare refID + fare flightID (from postFareDetails), NOT search refID + fare flightID
      const onwardFareRefID =
        flight?.fareRefID ||
        flight?.selectedOnwardFare?.refID ||
        flight?.selectedOnwardFare?.bookingRefID ||
        flight?.selectedFare?.refID ||
        flight?.selectedFare?.bookingRefID ||
        flight?.refID;
      const returnFareRefID =
        flight?.selectedReturnFare?.refID ||
        flight?.selectedReturnFare?.bookingRefID;

      const onwardRefIDToSend =
        onwardFareRefID ||
        flight?.onwardRefID ||
        onwardRefID;
      const returnRefIDToSend =
        returnFareRefID ||
        flight?.returnRefId ||
        statusDatas;

      // FTD V2: fare-specific flightID – one-way uses selectedFare; round-trip uses selectedOnwardFare + selectedReturnFare
      let onwardFareFlightID = null;
      let returnFareFlightID = null;

      if (flight?.isRoundTrip && !flight?.isInternational) {
        onwardFareFlightID = flight?.selectedOnwardFare?.flightID || flight?.selectedFare?.flightID;
        returnFareFlightID = flight?.selectedReturnFare?.flightID;

        if (!onwardFareFlightID || !returnFareFlightID) {
          throw new Error("Please select fares for both onward and return flights");
        }
      } else {
        onwardFareFlightID = flight?.selectedFare?.flightID || flight?.selectedOnwardFare?.flightID;

        if (!onwardFareFlightID) {
          throw new Error("Fare flightID missing – please select a fare and try again");
        }
      }

      // Explicitly extract what is strictly necessary for FTD + Backend
      // FTD Required Fields: flightID, refID, passenger, clientID, mobile, email, web_checkin, gst
      // Backend Required Fields: depCity, arrCity, onDate, reDate, depCName, arrCName, totalAmount, walletAmount
      const bookingPayload = {
        // --- Core FTD API Fields ---
        flightID: flight?.isRoundTrip ? (flight?.selectedOnwardFare?.flightID || flight?.selectedFare?.flightID || onwardFareFlightID) : onwardFareFlightID,
        returnFlightID: flight?.selectedReturnFare?.flightID,
        refID: onwardFareRefID || returnFareRefID || flight?.refID,
        onwardRefID: onwardRefIDToSend,
        returnRefID: returnRefIDToSend,
        clientID: clientId,
        passenger: passengerData,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        web_checkin: webCheckinSelected ? 1 : 0,
        includeSSR: selectedSsr?.type === "with",
        ...(gstInfo?.gstNo && { gstNo: gstInfo.gstNo, companyName: gstInfo.companyName || "", gstAddress: gstInfo.address || "" }),

        // --- Core FTD API Fields for SSR Extractions ---
        selectedSeats: selectedSeats,
        selectedBaggage: flight?.selectedBaggage || flight?.selectedFare?.baggageOption,
        selectedMeal: flight?.selectedMeal || flight?.selectedFare?.mealOption,
        selectedOnwardBaggage: flight?.selectedOnwardFare?.baggageOption || flight?.selectedOnwardFare?.ssrInfo?.baggageOption,
        selectedOnwardMeal: flight?.selectedOnwardFare?.mealOption || flight?.selectedOnwardFare?.ssrInfo?.mealOption,
        selectedReturnBaggage: flight?.selectedReturnFare?.baggageOption || flight?.selectedReturnFare?.ssrInfo?.baggageOption,
        selectedReturnMeal: flight?.selectedReturnFare?.mealOption || flight?.selectedReturnFare?.ssrInfo?.mealOption,
        selectedBaggagePerPax: selectedBaggagePerPax?.filter(Boolean) || [],
        selectedMealPerPax: selectedMealPerPax?.filter(Boolean) || [],

        // --- Backend Operational Fields ---
        totalAmount: amount || Number(flight?.totalPrice || flight?.selectedFare?.price || flight?.selectedFare?.totalPrice || (flight?.selectedOnwardFare?.price || 0) + (flight?.selectedReturnFare?.price || 0) || flight?.Fare?.total?.total || 0),
        priceSummary: priceSummary,
        ...(dataforWallet === "wallet" && amount != null
          ? { paymentMethod: "wallet", walletAmount: Number(amount) }
          : {}),
        tripType: tripType,
        serType: formData.serType,
        isRoundTrip: flight.isRoundTrip || false,
        depCity: searchPayload?.depCity,
        arrCity: searchPayload?.arrCity,
        onDate: searchPayload?.onDate,
        reDate: searchPayload?.reDate,
        depCName: flight?.flight?.Flights?.Onward?.[0]?.depCName || searchPayload?.depCity,
        arrCName: flight?.flight?.Flights?.Onward?.[0]?.arrCName || searchPayload?.arrCity,
      };

      if (flight?.isRoundTrip && !flight?.isInternational) {
        bookingPayload.onwardFlightID = onwardFareFlightID;
        bookingPayload.returnFlightID = returnFareFlightID;
      } else {
        bookingPayload.selectedFareFlightID = onwardFareFlightID;
        bookingPayload.flightID = onwardFareFlightID;
      }

      const response = await fetch(`${API_BASE}/api/checkAuth`, {
        credentials: "include",
      });
      const dataAuth = await response.json();

      if (!dataAuth?.success) {
        setShowLoginModal(true);
        return;
      }

      let endpoint = "/api/bookDomesticSingle";
      if (Number(formData.serType) === 1) {
        endpoint = flight.isRoundTrip ? "/api/bookDomesticRound" : "/api/bookDomesticSingle";
      } else {
        endpoint = flight.isRoundTrip ? "/api/bookIntlRound" : "/api/bookIntlSingle";
      }

      const res = await fetch(`${API_BASE}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(bookingPayload),
      });

      const data = await res.json();
      if (!res.ok || !data.success) {
        if (data.duplicate) {
          throw new Error(
            data.message || "Booking already completed with this reference. Please check My Bookings."
          );
        }
        throw new Error(data.message || "Booking failed");
      }

      const calculatedTotal = flight?.Fare?.total?.total
        ? Number(flight.Fare.total.total) + 300
        : data.data?.totalAmount || 0;

      const bookingId =
        data.data?.Status?.refID ||
        data.data?.Status?.bookingReference ||
        data.data?.bookingReference ||
        data.data?.refID ||
        statusDatas ||
        "N/A";

      const emailResult = await sendBookingConfirmationEmail({
        flightInfo: flight,
        passengerDetails: passengerData,
        contactInfo: { mobile: contactInfo.mobile, email: contactInfo.email },
        selectedSeats: selectedSeats,
        totalAmount: calculatedTotal,
        bookingReference: bookingId,
      });

      setBookingResult(data.data);
      setBookingSuccessData({
        ...data.data,
        bookingReference: bookingId,
        totalAmount: calculatedTotal,
        userEmail: contactInfo.email,
        emailSent: emailResult.success,
        emailMessage: emailResult.message,
      });
      setShowBookingSuccess(true);
      // Wallet is deducted by backend only after booking success (no frontend deduct)

      return data.data;
    } catch (e) {
      setBookingError(e.message);
      throw e;
    } finally {
      setIsBooking(false);
    }
  };

  // Function to combine flight results for round trips
  const combineFlightResults = (onwardFlights, returnFlights) => {
    const combined = [];
    const MAX_COMBINATIONS = 100; // Limit to top 100 combinations to avoid overwhelming UI (was showing 8000+)

    // Create all possible combinations
    onwardFlights.forEach((onwardFlight, onwardIndex) => {
      returnFlights.forEach((returnFlight, returnIndex) => {
        combined.push({
          id: `${onwardIndex}-${returnIndex}`,
          isRoundTrip: true,
          onwardFlight: onwardFlight,
          returnFlight: returnFlight,
          // Calculate total price (addition, not multiplication)
          totalPrice: (
            parseInt(onwardFlight.Fare?.total?.total || 0) +
            parseInt(returnFlight.Fare?.total?.total || 0)
          ).toString(),
          // Calculate total duration (addition)
          totalDuration:
            getTotalDurationMinutes(onwardFlight?.Flights?.Onward) +
            getTotalDurationMinutes(returnFlight?.Flights?.Onward),
        });
      });
    });

    // Sort by cheapest by default
    const sortedCombined = combined.sort(
      (a, b) => parseInt(a.totalPrice) - parseInt(b.totalPrice)
    );

    // Return top N combinations instead of all (prevents showing 8000+ flights)
    return sortedCombined.slice(0, MAX_COMBINATIONS);
  };

  // Sorting function
  const sortFlights = (flights, criteria) => {
    const sorted = [...flights];

    switch (criteria) {
      case "cheapest":
        return sorted.sort((a, b) => {
          const priceA = a.isRoundTrip
            ? parseInt(a.totalPrice)
            : parseInt(a.Fare?.total?.total || 0);
          const priceB = b.isRoundTrip
            ? parseInt(b.totalPrice)
            : parseInt(b.Fare?.total?.total || 0);
          return priceA - priceB;
        });

      case "fastest":
        return sorted.sort((a, b) => {
          const durationA = a.isRoundTrip
            ? a.totalDuration
            : getTotalDurationMinutes(a?.Flights?.Onward);
          const durationB = b.isRoundTrip
            ? b.totalDuration
            : getTotalDurationMinutes(b?.Flights?.Onward);
          return durationA - durationB;
        });

      case "special":
        // Sort by special deals or airline preference
        return sorted.sort((a, b) => {
          const airlineA = a.isRoundTrip
            ? a.onwardFlight?.Flights?.AirlineName
            : a.Flights?.AirlineName;
          const airlineB = b.isRoundTrip
            ? b.onwardFlight?.Flights?.AirlineName
            : b.Flights?.AirlineName;
          return airlineA?.localeCompare(airlineB) || 0;
        });

      default:
        return sorted;
    }
  };

  // Apply sorting when sortBy changes
  useEffect(() => {
    if (combinedResults.length > 0) {
      const sorted = sortFlights(combinedResults, sortBy);
      setCombinedResults(sorted);
    }
  }, [sortBy]);

  // Optimized handleSearch function - FIXED VERSION
  const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSearchResults({ onward: [], return: [] });
    setCombinedResults([]);
    setShowResults(false);
    ref.current = 1; // Reset so domestic round trip: first call = onward, second = return
    setDebugInfo("Starting search process...");

    try {
      if (!formData.from || !formData.to || !formData.departure) {
        throw new Error(
          "Please fill in all required fields (From, To, and Departure Date)"
        );
      }

      if (tripType == 1 && !formData.returnDate) {
        throw new Error("Please select a Return Date for Round Trip");
      }

      const totalNonInfant = (formData.adults || 0) + (formData.children || 0);
      if (formData.adults < 1 || formData.adults > 9) {
        throw new Error("Adults must be between 1 and 9");
      }
      if (totalNonInfant > 9) {
        throw new Error("Total of Adults + Children cannot exceed 9");
      }
      if (formData.infants > Math.min(4, formData.adults)) {
        throw new Error("Infants cannot be more than Adults and maximum 4");
      }

      const extractCodeFromDisplay = (displayValue) => {
        if (!displayValue) return null;
        const match = displayValue.match(/\(([A-Z]{3})\)/);
        return match ? match[1] : null;
      };

      const fromLocation = airports.find((airport) => {
        const displayFormats = [
          `${airport.name} (${airport.code})`,
          `${airport.name}, ${airport.country} (${airport.code})`,
          `${airport.city} (${airport.code})`,
          `${airport.city}, ${airport.country} (${airport.code})`,
        ];

        if (displayFormats.some((format) => format === formData.from)) {
          return true;
        }

        if (formData.from === airport.code) {
          return true;
        }

        const extractedCode = extractCodeFromDisplay(formData.from);
        if (extractedCode && extractedCode === airport.code) {
          return true;
        }

        return false;
      });

      const toLocation = airports.find((airport) => {
        const displayFormats = [
          `${airport.name} (${airport.code})`,
          `${airport.name}, ${airport.country} (${airport.code})`,
          `${airport.city} (${airport.code})`,
          `${airport.city}, ${airport.country} (${airport.code})`,
        ];

        if (displayFormats.some((format) => format === formData.to)) {
          return true;
        }

        if (formData.to === airport.code) {
          return true;
        }

        const extractedCode = extractCodeFromDisplay(formData.to);
        if (extractedCode && extractedCode === airport.code) {
          return true;
        }

        return false;
      });

      if (!fromLocation || !toLocation) {
        throw new Error(
          "Please select valid departure and arrival locations from the dropdown"
        );
      }

      // Auto-derive service type from airport countries (V2: airport-based)
      // Domestic (serType 1) when both From and To are in India; else International (serType 2).
      // Treat India: exact "India"/"IN"/"IND" or string containing "india" (e.g. "Mumbai, India") so BOM/IDR/MAA work correctly.
      const fromCountry = (fromLocation.country || "").trim();
      const toCountry = (toLocation.country || "").trim();
      const isIndia = (c) => {
        if (!c || typeof c !== "string") return false;
        const t = c.trim().toLowerCase();
        return t === "india" || t === "in" || t === "ind" || t.includes("india");
      };
      // Only treat as International if we have a non-India country; empty/unknown defaults to domestic
      const isInternational =
        (fromCountry && !isIndia(fromCountry)) || (toCountry && !isIndia(toCountry));
      const derivedSerType = isInternational ? 2 : 1;

      console.log("🛫 [Flight Search] Service type (airport-based):", {
        from: { code: fromLocation.code, country: fromCountry },
        to: { code: toLocation.code, country: toCountry },
        derivedSerType,
        label: derivedSerType === 1 ? "Domestic" : "International",
      });
      console.log(
        `🛫 [Flight Search] Service type sent to API: ${derivedSerType} (${derivedSerType === 1 ? "Domestic" : "International"})`
      );

      // Sync form so UI and downstream logic (e.g. result branching) use same value
      setFormData((prev) =>
        prev.serType === derivedSerType ? prev : { ...prev, serType: derivedSerType }
      );

      const formatDate = (iso) => (iso ? iso.replaceAll("-", "") : "");

      // IMPORTANT: Always send the actual tripType to the API
      // serType is derived from airports so API gets correct domestic/international
      const searchData = {
        tripType: tripType, // Send 0 for one-way, 1 for round trip
        serType: derivedSerType,
        depCity: fromLocation.code,
        arrCity: toLocation.code,
        onDate: formatDate(formData.departure),
        reDate: tripType === 1 ? formatDate(formData.returnDate) : "",
        adt: formData.adults,
        chd: formData.children,
        inf: formData.infants,
        cabin: formData.cabin,
        fareType: formData.fareType,
      };

      setDebugInfo(`Sending search request: ${JSON.stringify(searchData)}`);
      setLastSearchPayload(searchData);

      // International round trip: FTD supports single API call for International Round Trip
      const isInternationalRoundTrip = false; // derivedSerType === 2 && tripType === 1;
      let searchResponse;
      if (isInternationalRoundTrip) {
        ref.current = 1;
        const onwardSearchData = {
          tripType: 0,
          serType: derivedSerType,
          depCity: fromLocation.code,
          arrCity: toLocation.code,
          onDate: formatDate(formData.departure),
          reDate: "",
          adt: formData.adults,
          chd: formData.children,
          inf: formData.infants,
          cabin: formData.cabin,
          fareType: formData.fareType,
        };
        setDebugInfo("International round trip - searching onward leg...");
        searchResponse = await searchFlights(onwardSearchData);
      } else {
        // Single API call for one-way (domestic + international) and domestic round trip (first call)
        searchResponse = await searchFlights(searchData);
      }

      if (searchResponse) {
        setStatusRefdId(searchResponse?.Status?.refID || searchResponse?.status?.refID || "");

        // Extract flights from searchResponse (V2 structure - same for one-way and round trip)
        const flights = searchResponse?.results || searchResponse?.flights || searchResponse?.data?.flights || searchResponse?.data?.Results || searchResponse?.data?.results || [];

        // V2: Handle different response structures based on service type (use derived value we sent to API)
        if (derivedSerType === 2) {
          // INTERNATIONAL FLIGHTS
          if (tripType === 1) {
            // International round trip: 2-search flow (onward done above; now return leg)
            if (isInternationalRoundTrip) {
              setDebugInfo("International round trip - searching return leg...");
              const returnSearchData = {
                tripType: 0,
                serType: derivedSerType,
                depCity: toLocation.code,
                arrCity: fromLocation.code,
                onDate: formatDate(formData.returnDate),
                reDate: "",
                adt: formData.adults,
                chd: formData.children,
                inf: formData.infants,
                cabin: formData.cabin,
                fareType: formData.fareType,
              };
              const returnResults = await searchFlights(returnSearchData);
              const returnFlights = returnResults?.results || returnResults?.flights || [];

              setSearchResults({ onward: flights, return: returnFlights });
              if (returnFlights.length > 0) {
                const combined = combineFlightResults(flights, returnFlights);
                // Shape for InternationalRoundTripFlightCard: Flights.Onward + Flights.Return, Fare
                setCombinedResults(
                  combined.map((c) => ({
                    ...c,
                    Flights: {
                      Onward: c.onwardFlight?.Flights?.Onward ?? c.onwardFlight,
                      Return: c.returnFlight?.Flights?.Onward ?? c.returnFlight,
                    },
                    Fare: {
                      total: { total: c.totalPrice ?? 0 },
                      Onward: c.onwardFlight?.Fare,
                      Return: c.returnFlight?.Fare,
                    },
                  }))
                );
              } else {
                setCombinedResults(
                  flights.map((flight) => ({
                    ...flight,
                    isRoundTrip: false,
                    onwardFlight: flight,
                    returnFlight: null,
                  }))
                );
              }
            } else {
              // Fallback: single response with both Onward and Return
              const roundTripFlights = flights.filter((f) => f.Flights?.Onward && f.Flights?.Return);
              if (roundTripFlights.length > 0) {
                setSearchResults({ onward: roundTripFlights, return: [] });
                setCombinedResults(
                  roundTripFlights.map((flight) => ({
                    ...flight,
                    isRoundTrip: false, // Important: must be false for InternationalRoundTripFlightCard to render
                    onwardFlight: flight,
                    returnFlight: flight,
                  }))
                );
              } else if (searchResponse.onward && searchResponse.return) {
                setSearchResults({ onward: searchResponse.onward, return: searchResponse.return });
                const combined = combineFlightResults(searchResponse.onward, searchResponse.return);
                setCombinedResults(combined);
              } else {
                setSearchResults({ onward: flights, return: [] });
                setCombinedResults(
                  flights.map((flight) => ({
                    ...flight,
                    isRoundTrip: false,
                    onwardFlight: flight,
                    returnFlight: null,
                  }))
                );
              }
            }
          } else {
            // International one-way
            setSearchResults({ onward: flights, return: [] });
            setCombinedResults(
              flights.map((flight) => ({
                ...flight,
                isRoundTrip: false,
                onwardFlight: flight,
                returnFlight: null,
              }))
            );
          }
        } else {
          // DOMESTIC FLIGHTS
          if (tripType === 1) {
            // Domestic round trip - need separate return search
            if (searchResponse.returnResults) {
              setSearchResults({
                onward: flights,
                return: searchResponse.returnResults,
              });
              const combined = combineFlightResults(flights, searchResponse.returnResults);
              setCombinedResults(combined);
            } else {
              // Make separate return search
              setDebugInfo("Domestic round trip - searching for return flights...");

              const returnSearchData = {
                tripType: 0,
                serType: derivedSerType,
                depCity: toLocation.code,
                arrCity: fromLocation.code,
                onDate: formatDate(formData.returnDate),
                reDate: "",
                adt: formData.adults,
                chd: formData.children,
                inf: formData.infants,
                cabin: formData.cabin,
                fareType: formData.fareType,
              };

              const returnResults = await searchFlights(returnSearchData);
              const returnFlights = returnResults?.results || returnResults?.flights || [];

              if (returnFlights.length > 0) {
                setSearchResults({
                  onward: flights,
                  return: returnFlights,
                });
                const combined = combineFlightResults(flights, returnFlights);
                setCombinedResults(combined);
              } else {
                setCombinedResults(
                  flights.map((flight) => ({
                    ...flight,
                    isRoundTrip: false,
                    onwardFlight: flight,
                    returnFlight: null,
                  }))
                );
              }
            }
          } else {
            // Domestic one-way
            setSearchResults({ onward: flights, return: [] });
            setCombinedResults(
              flights.map((flight) => ({
                ...flight,
                isRoundTrip: false,
                onwardFlight: flight,
                returnFlight: null,
              }))
            );
          }
        }

        setShowResults(true);
        storeNextDayDate();
      } else {
        throw new Error("No flight results received from server");
      }
    } catch (error) {
      console.error("Search error:", error);
      setError(error.message);
      setDebugInfo(`Final error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleDropdown = (dropdown) => {
    setDropdowns((prev) => {
      const wasOpen = !!prev[dropdown];
      const closedAll = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return {
        ...closedAll,
        [dropdown]: !wasOpen,
      };
    });
  };

  const selectOption = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setDropdowns((prev) => ({
      ...prev,
      [field]: false,
    }));
  };

  const swapLocations = () => {
    setFormData((prev) => ({
      ...prev,
      from: prev.to,
      to: prev.from,
    }));
  };

  const toggleFlightDetails = (flightIndex) => {
    setExpandedFlights((prev) => ({
      ...prev,
      [flightIndex]: !prev[flightIndex],
    }));
  };

  // Generate unique clientID

  const generateClientID = () => {
    return authdata?.token?._id;
  };

  // Derived auth state

  // Initialize passenger form data
  const initializePassengerData = useCallback(() => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const initialData = [];

    for (let i = 0; i < totalpassenger; i++) {
      initialData[i] = {
        title: "Mr",
        fName: "",
        lName: "",
        gender: "M",
        dob: "",
        ppNo: "",
        ppIss: "",
        ppExp: "",
        ppNat: "IN",
        // V2: Add document_id and panNo fields
        document_id: "",
        panNo: "",
      };
    }

    setFormPassengerData(initialData);
  }, [formData.adults, formData.children, formData.infants]);

  // Initialize passenger data when form opens
  useEffect(() => {
    if (showPassengerForm) {
      initializePassengerData();
    }
  }, [showPassengerForm, initializePassengerData]);

  // Handle passenger form data changes
  const handlePassengerDataChange = (passengerIndex, field, value) => {
    setFormPassengerData((prev) => {
      const newData = [...prev];
      newData[passengerIndex] = {
        ...newData[passengerIndex],
        [field]: value,
      };
      return newData;
    });

    setValue(`passengers.${passengerIndex}.${field}`, value, {
      shouldValidate: false,
      shouldDirty: true,
    });
  };

  // Convert date from YYYY-MM-DD to DD-MM-YYYY format
  const formatDateForAPI = (dateString) => {
    if (!dateString) return "01-01-1990";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // V2: Generate passenger details from form data with document_id and PAN support
  const generatePassengerDetails = () => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const passenger = [];

    if (totalpassenger === 0) {
      const defaultPassenger = {
        title: "Mr",
        fName: "Test",
        lName: "User",
        pType: "A",
        gender: "M",
        dob: "01-01-1990",
        mobile: contactInfo.mobile || "",
        email: contactInfo.email || "",
        // V2: Add document_id and panNo if available
        ...(formPassengerData[0]?.document_id && { document_id: formPassengerData[0].document_id }),
        ...(formPassengerData[0]?.panNo && { panNo: String(formPassengerData[0].panNo).trim().toUpperCase() }),
      };

      if (formData.serType == 2) {
        defaultPassenger.ppNo = "";
        defaultPassenger.ppIss = "";
        defaultPassenger.ppExp = "";
        defaultPassenger.ppNat = "IN";
      }

      return [defaultPassenger];
    }

    for (let i = 0; i < totalpassenger; i++) {
      const passengerData = formPassengerData[i] || [];
      const passengerType =
        i < formData.adults
          ? "A"
          : i < formData.adults + formData.children
            ? "C"
            : "I";

      const passengerObj = {
        title: passengerData.title || "Mr",
        fName: passengerData.fName || "Test",
        lName: passengerData.lName || "User",
        pType: passengerType,
        gender: passengerData.gender || "M",
        dob: formatDateForAPI(passengerData.dob),
      };

      // V2: Add document_id for Student/Sr Citizen/Defence fares
      if (passengerData.document_id) {
        passengerObj.document_id = passengerData.document_id;
      }

      // V2: Add panNo only for first passenger (SOTO bookings / International)
      if (i === 0 && passengerData.panNo) {
        passengerObj.panNo = String(passengerData.panNo).trim().toUpperCase();
      }

      if (formData.serType == 2) {
        passengerObj.ppNo = passengerData.ppNo || "";
        passengerObj.ppIss = formatDateForAPI(passengerData.ppIss);
        passengerObj.ppExp = formatDateForAPI(passengerData.ppExp);
        passengerObj.ppNat = passengerData.ppNat || "IN";
      }

      passenger.push(passengerObj);
    }

    return passenger;
  };

  // Helper functions for flight data
  const formatApiDateTime = (str) => {
    if (!str || str.length < 12) return "N/A";
    const y = Number(str.slice(0, 4));
    const m = Number(str.slice(4, 6)) - 1;
    const d = Number(str.slice(6, 8));
    const hh = Number(str.slice(8, 10));
    const mm = Number(str.slice(10, 12));
    const dt = new Date(y, m, d, hh, mm);
    return dt.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const minutesToHm = (minsStr) => {
    const mins = Number(minsStr || 0);
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
  };

  const getSegments = (leg) => {
    if (!leg) return [];
    const vals = Array.isArray(leg) ? leg : Object.values(leg);
    return vals.filter((s) => s && s.flightNo);
  };

  const getStopsText = (leg) => {
    const segs = getSegments(leg);
    const stops = Math.max(0, segs.length - 1);
    if (stops === 0) return "Non-stop";
    const vias = segs
      .slice(0, -1)
      .map((s) => s.arrCode)
      .join(", ");
    return `${stops} Stop${stops > 1 ? "s" : ""}${vias ? ` via ${vias}` : ""}`;
  };

  const getTotalDurationMinutes = (leg) => {
    if (!leg) return 0;
    if (leg.durTotal) return Number(leg.durTotal);
    const segs = getSegments(leg);
    return segs.reduce((sum, s) => sum + Number(s.duration || 0), 0);
  };

  // Send booking confirmation email
  const sendBookingConfirmationEmail = async (bookingData) => {
    try {
      const emailData = {
        to: bookingData.contactInfo?.email || "itzzzamaan001@gmail.com",
        subject: "Flight Booking Confirmation",
        bookingDetails: {
          flightInfo: bookingData.flightInfo || {},
          passengerDetails: bookingData.passengerDetails || [],
          contactInfo: bookingData.contactInfo || {},
          selectedSeats: bookingData.selectedSeats || {},
          totalAmount: bookingData.totalAmount || 0,
          bookingReference: bookingData.bookingReference || "N/A",
          bookingDate: new Date().toLocaleString(),
        },
      };

      await new Promise((resolve) => setTimeout(resolve, 1000));

      return {
        success: true,
        message: "Booking confirmation email sent successfully",
      };
    } catch (error) {
      console.error("Error sending booking confirmation email:", error);
      return { success: false, message: "Failed to send confirmation email" };
    }
  };

  // Set minimum date for departure as today
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Set minimum return date as departure date
  const getMinReturnDate = () => {
    return formData.departure || getTodayDate();
  };

  const handleAuthCheck = async (fare) => {
    setSelectedFlightForPrice(fare);

    const response = await fetch(`${API_BASE}/api/checkAuth`, {
      credentials: "include",
    });
    const dataAuth = await response.json();
    if (!dataAuth?.success) {
      setShowLoginModal(true);
      return;
    }

    // Call postPriceVerify to check price and Web Checkin availability
    try {
      if (fare?.isRoundTrip && formData?.serType === 1) {
        // DOMESTIC ROUND TRIP
        const onwardFlightID = fare?.selectedOnwardFare?.flightID || fare?.onwardFlight?.flightID;
        const onwardRefID = fare?.selectedOnwardFare?.refID || fare?.selectedOnwardFare?.bookingRefID || fare?.onwardRefID;
        const returnFlightID = fare?.selectedReturnFare?.flightID || fare?.returnFlight?.flightID;
        const returnRefID = fare?.selectedReturnFare?.refID || fare?.selectedReturnFare?.bookingRefID || fare?.returnRefId;

        if (onwardFlightID && onwardRefID && returnFlightID && returnRefID) {
          const [onwardRes, returnRes] = await Promise.all([
            fetch(`${API_BASE}/api/postPriceVerify`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ flightID: onwardFlightID, refID: onwardRefID })
            }),
            fetch(`${API_BASE}/api/postPriceVerify`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ flightID: returnFlightID, refID: returnRefID })
            })
          ]);

          const onwardVerifyData = await onwardRes.json();
          const returnVerifyData = await returnRes.json();

          if (onwardVerifyData.success && returnVerifyData.success) {
            const onwardResult = onwardVerifyData.data?.result || {};
            const returnResult = returnVerifyData.data?.result || {};

            // Merge Validation for priceCheckData
            fare.priceCheckData = {
              ...onwardResult.Validation,
              ...returnResult.Validation
            };

            // Merge ssrInfo 
            fare.ssrInfo = {
              ...(fare.ssrInfo || {}),
              Onward: onwardResult.ssrInfo,
              Return: returnResult.ssrInfo,
              // Use onward for generic web checkin info, or merge them
              web_checkin_enabled: onwardResult.ssrInfo?.web_checkin_enabled || returnResult.ssrInfo?.web_checkin_enabled,
              web_checkin_amount: Math.max(Number(onwardResult.ssrInfo?.web_checkin_amount || 0), Number(returnResult.ssrInfo?.web_checkin_amount || 0))
            };
          } else {
            alert("Price verify failed for round trip. Flight might be unavailable");
            return;
          }
        }
      } else {
        // ONE WAY or INTERNATIONAL ROUND TRIP (Bundled)
        const flightIDToVerify = fare?.flightID || fare?.selectedFare?.flightID || fare?.flightId;
        const refIDToVerify = fare?.refID || fare?.selectedFare?.refID || fare?.bookingRefID;

        if (flightIDToVerify && refIDToVerify) {
          const verifyRes = await fetch(`${API_BASE}/api/postPriceVerify`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ flightID: flightIDToVerify, refID: refIDToVerify })
          });
          const verifyData = await verifyRes.json();

          if (verifyData.success) {
            const resultObj = verifyData.data?.result || {};
            fare.priceCheckData = resultObj.Validation || {};

            fare.ssrInfo = {
              ...(fare.ssrInfo || {}),
              ...(resultObj.ssrInfo || {})
            };
          } else {
            alert("Price verify failed: " + (verifyData.message || "Flight might be unavailable"));
            return;
          }
        }
      }
    } catch (e) {
      console.error("Price verify error:", e);
      alert("Failed to verify price before booking.");
      return;
    }

    // V2: Check if fare requires document or PAN from price check response
    // FTD requires PAN for International (serType 2) – always mandatory regardless of API response
    const priceCheckData = fare?.priceCheckData || {};
    const requiresDocument = priceCheckData?.doc_mandatory === 1 || fare?.doc_mandatory === 1;
    const requiresPAN = formData?.serType == 2 || priceCheckData?.pan_mandatory === 1 || fare?.pan_mandatory === 1;
    const documentType = priceCheckData?.document_type || fare?.document_type || ""; // 1=Student, 2=Sr Citizen, 3=Defence

    // Store V2 requirements in fare object for use in passenger form
    fare.requiresDocument = requiresDocument;
    fare.requiresPAN = requiresPAN;
    fare.documentType = documentType === 1 ? "student" : documentType === 2 ? "senior" : documentType === 3 ? "defence" : "";

    setSelectedFare(fare);
    setGstInfo({ gstNo: "", companyName: "", address: "" });
    setShowPassengerForm(true);
    // V2: Default SSR choice – include add-ons if user already selected baggage/meal on fare card
    const hasAddOns = fare?.selectedBaggage || fare?.selectedMeal ||
      fare?.selectedOnwardFare?.selectedBaggage || fare?.selectedOnwardFare?.selectedMeal;
    setSelectedSsr(hasAddOns ? { type: "with" } : { type: "without" });
  };

  // ✅ DOB validation helper
  const handleDobChange = (value, index, type) => {
    const dobDate = new Date(value);

    if (type === "infant") {
      if (dobDate < sixtyDaysAgo || dobDate > today) {
        alert("Infant DOB must be within the last 60 days");
        return;
      }
    }
    if (type === "child") {
      if (dobDate < twelveYearsAgo || dobDate > today) {
        alert("Child DOB must be within the last 12 years");
        return;
      }
    }

    setFormPassengerData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        dob: value,
      };
      return updatedData;
    });

    setValue(`passengers.${index}.dob`, value, {
      shouldValidate: false,
      shouldDirty: true,
    });
  };

  // Booking execution with SSR selection
  const handleBooking = async (data = "", amount) => {
    try {
      // V2: PAN is mandatory for International (serType 2) – validate before booking
      if (formData?.serType == 2) {
        const firstPaxPan = (formPassengerData[0]?.panNo || "").trim().toUpperCase();
        if (!firstPaxPan || firstPaxPan.length !== 10) {
          setBookingError("PAN Number is mandatory for International flights. Please enter valid PAN for the first passenger (format: ABCDE1234F).");
          return;
        }
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(firstPaxPan)) {
          setBookingError("Invalid PAN format. Please enter valid PAN (format: ABCDE1234F – 5 letters, 4 numbers, 1 letter).");
          return;
        }
      }

      // Generate clientID
      const clientId = generateClientID();

      // Get flightID and refID from localStorage
      const storedFlightData = getFlightDataFromStorage();

      // Get the full status object from localStorage
      let statusData = null;
      try {
        const flightStatus = localStorage.getItem("flightStatus");
        if (flightStatus) {
          statusData = JSON.parse(flightStatus);
        }
      } catch (error) {
        console.error("Error parsing status from localStorage:", error);
      }

      const flightId =
        storedFlightData.flightID || selectedFlightForPrice.flightID;
      const refId = storedFlightData.refID || selectedFlightForPrice.refID;

      // Generate passenger details from form data
      const generatedpassenger = generatePassengerDetails();

      const bookingData = {
        passenger: generatedpassenger,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        status: statusData,
        selectedSeats: selectedSeats,
      };

      // V2: All bookings (with or without SSR) use main /bookFlight – backend extracts SSR from selected fares
      await bookSelectedFlight(
        selectedFlightForPrice,
        passengerDetails,
        lastSearchPayload || {},
        data,
        amount
      );
    } catch (error) {
      console.error("Booking error", error);
      setBookingError(error?.message || "Booking failed. Please try again.");
      setIsOpen(false);
    }
  };

  // Wallet can be a number (balance) or object { balance, status, isActive, ... }
  const walletBalance =
    userWallet != null && typeof userWallet === "object"
      ? Number(userWallet.balance ?? userWallet.amount ?? userWallet.currentBalance ?? 0)
      : Number(userWallet ?? 0);
  const isWalletActive =
    userWallet != null &&
    (typeof userWallet === "object"
      ? (userWallet.isActive === true || userWallet.status === "active")
      : true);
  const hasSufficientWalletBalance =
    isWalletActive && walletBalance >= totalPayableAmount;

  const handlePay = async (onSuccess) => {
    try {
      if (!selectedFlightForPrice) {
        alert("Please select a flight and fare option first.");
        setIsPaying(false);
        return;
      }
      if (!amount) {
        alert("Please set the amount first.");
        setIsPaying(false);
        return;
      }
      // V2: PAN mandatory for International – validate before payment
      if (formData?.serType == 2) {
        const firstPaxPan = (formPassengerData[0]?.panNo || "").trim().toUpperCase();
        if (!firstPaxPan || firstPaxPan.length !== 10) {
          alert("PAN Number is mandatory for International flights. Please enter valid PAN for the first passenger (format: ABCDE1234F).");
          setIsPaying(false);
          return;
        }
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(firstPaxPan)) {
          alert("Invalid PAN format. Please enter valid PAN (format: ABCDE1234F – 5 letters, 4 numbers, 1 letter).");
          setIsPaying(false);
          return;
        }
      }

      const { data } = await axios.post(
        `${API_BASE}/create-order`,
        {
          amount: amount,
        },
        { withCredentials: true }
      );

      if (!data?.order) {
        alert("Failed to create order");
        setIsPaying(false);
        return;
      }

      const options = {
        key: import.meta.env.VITE_KEYID,
        amount: data.order.amount,
        currency: "INR",
        name: "FTD Travel",
        description: "Flight Booking Payment",
        order_id: data.order.id,
        handler: function (response) {
          alert("Payment successful!");
          if (typeof onSuccess === "function") {
            onSuccess(response);
          }
        },
        prefill: {
          name: "YUSUF KHAN",
          email: "yusuf@example.com",
          contact: "9999999999",
        },
        notes: {
          address: "FTD Travel Office",
        },
        theme: {
          color: "#3399cc",
        },
      };

      if (!window.Razorpay) {
        alert("Payment system not available. Please try again later.");
        setIsPaying(false);
        return;
      }

      const razor = new window.Razorpay(options);
      razor.open();

      if (razor && typeof razor.on === "function") {
        try {
          razor.on("modal.closed", function () {
            setIsPaying(false);
          });
        } catch (err) {
          console.error(err);
        }
      }

      razor.on("payment.failed", function (response) {
        console.error("❌ Payment Failed:", response.error);
        alert("Payment failed. Please try again.");
        setIsPaying(false);
      });
    } catch (err) {
      console.error("Payment Error:", err);
      setIsPaying(false);
    }
  };

  // const handleWalletPayment = async () => {
  //   try {
  //     if (!isWalletActive) {
  //       toast.error(
  //         "Please go to your profile and click on Activate Wallet. Our team will contact you."
  //       );
  //       return;
  //     }

  //     if (!hasSufficientWalletBalance) {
  //       toast.error(
  //         "Insufficient wallet balance. Please go to your profile and send a request to admin."
  //       );
  //       return;
  //     }

  //     const res = await axios.post(
  //       `${API_BASE}/api/wallet/pay`,
  //       { amount: totalPayableAmount },
  //       { withCredentials: true }
  //     );

  //     if (!res.data.success) {
  //       toast.error(res.data.message || "Wallet payment failed");
  //       return;
  //     }

  //     await handleBooking("wallet", totalPayableAmount);

  //     toast.success("Payment successful using Wallet");
  //     setIsOpen(false);
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Wallet payment failed");
  //   }
  // };

  const handleWalletPayment = async () => {
    // ✅ Confirmation first
    const confirmed = window.confirm(
      `Are you sure you want to pay ₹${totalPayableAmount} from your wallet?`
    );

    if (!confirmed) return;

    try {
      setIsWalletProcessing(true); // 🔒 disable all payment buttons

      // V2: PAN mandatory for International – validate before payment
      if (formData?.serType == 2) {
        const firstPaxPan = (formPassengerData[0]?.panNo || "").trim().toUpperCase();
        if (!firstPaxPan || firstPaxPan.length !== 10) {
          alert("PAN Number is mandatory for International flights. Please enter valid PAN for the first passenger (format: ABCDE1234F).");
          setIsWalletProcessing(false);
          return;
        }
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(firstPaxPan)) {
          alert("Invalid PAN format. Please enter valid PAN (format: ABCDE1234F – 5 letters, 4 numbers, 1 letter).");
          setIsWalletProcessing(false);
          return;
        }
      }

      if (!isWalletActive) {
        alert(
          "Please go to your profile and click on Activate Wallet. Our team will contact you."
        );
        return;
      }

      if (!hasSufficientWalletBalance) {
        alert(
          "Insufficient wallet balance. Please go to your profile and send a request to admin."
        );
        return;
      }

      // 0️⃣ Check duplicate: avoid booking if this refID is already booked
      try {
        const refID = selectedFlightForPrice?.refID;
        const onwardRefID = selectedFlightForPrice?.onwardRefID;
        const returnRefId = selectedFlightForPrice?.returnRefId;
        const checkRes = await axios.post(
          `${API_BASE}/api/checkDuplicateBeforeBooking`,
          { refID, onwardRefID, returnRefId },
          { withCredentials: true }
        );
        if (checkRes.data?.duplicate) {
          alert(
            checkRes.data.message || "Booking already completed with this reference. Please check My Bookings."
          );
          return;
        }
      } catch (checkErr) {
        console.warn("Duplicate check failed, proceeding:", checkErr);
      }

      // 1️⃣ Book flight first; backend deducts wallet only after booking success (no deduction on failure)
      await handleBooking("wallet", totalPayableAmount);

      alert("Payment successful using Wallet");
      setIsOpen(false);
    } catch (err) {
      console.error(err);
      // Show backend message on 403/4xx (e.g. "Wallet is not active", "Wallet amount is not enough")
      const backendMsg = err?.response?.data?.message;
      const currentBalance = err?.response?.data?.currentBalance;
      const msg = backendMsg || err?.message || "Wallet payment failed";
      alert(currentBalance != null ? `${msg} (Current balance: ₹${currentBalance})` : msg);
    } finally {
      setIsWalletProcessing(false); // 🔓 re-enable buttons
    }
  };

  const initiateBooking = () => {
    if (isPaying) return;
    setIsPaying(true);
    handlePay(async (paymentResponse) => {
      try {
        await handleBooking();

        setIsPaying(false);
        setIsOpen(false);
      } catch (error) {
        console.error("Booking error:", error);
        setIsPaying(false);
      }
    });
  };

  // Store next day date in localStorage when flight search is successful
  const storeNextDayDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    localStorage.setItem("flightSearchUpdateDate", tomorrow.toISOString());
  };

  // Clear all localStorage and cookies, then store next day date
  const handleUpdateStorage = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    storeNextDayDate();
    setShowUpdateModal(false);
    toast.success("Storage updated successfully!", {
      position: "top-center",
      autoClose: 3000,
    });
  };

  // Handle feedback submission
  const handleFeedbackSubmit = async () => {
    if (rating === 0) {
      toast.error("Please provide a rating", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmittingFeedback(true);
    try {
      const response = await axios.post(
        `${API_BASE}/api/review/create`,
        {
          rating: String(rating),
          description: feedbackText || "",
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Thank you for your feedback!", {
          position: "top-center",
          autoClose: 3000,
        });
        setShowFeedbackModal(false);
        setShowPassengerForm(false);
        setShowPriceModal(false);
        setBookingSuccessData(null);
        setRating(0);
        setFeedbackText("");
      } else {
        toast.error(
          response.data.message ||
          "Failed to submit feedback. Please try again.",
          {
            position: "top-center",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.error("Feedback submission error:", error);
      if (error.response?.status === 401) {
        toast.error("Please login to submit feedback", {
          position: "top-center",
          autoClose: 3000,
        });
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Failed to submit feedback. Please try again.", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } finally {
      setIsSubmittingFeedback(false);
    }
  };

  // Fetch airports on component mount
  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/airport`, {
          credentials: "include",
        });
        const data = await response.json();
        if (data.success && data.data) {
          const mappedAirports = data.data.map((airport) => ({
            code: airport.airportcode || airport.code,
            name: airport.airportname || airport.name,
            city: airport.airportcity || airport.city,
            country: airport.airportcountry || airport.country,
            airport: airport.airportname || airport.name,
          }));
          setAirports(mappedAirports);
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);

  return (
    <div>
      <div
        className="min-h-[88vh] md:min-h-[90vh] pb-10 pt-6 relative overflow-hidden flex flex-col"
        style={{
          backgroundImage: `url(${flighthome})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Overlay: gradient for readability + subtle vignette */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "linear-gradient(135deg, rgba(15,23,42,0.72) 0%, rgba(30,58,138,0.45) 40%, rgba(15,23,42,0.65) 100%)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-transparent to-transparent pointer-events-none" />

        {/* Background plane: subtle, blended */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            className="absolute md:top-16 top-14 right-8 md:right-16 w-64 h-64 md:w-80 md:h-80"
            initial={{ x: 80, y: -30, rotate: 12, opacity: 0.4 }}
            animate={{ x: 0, y: 0, rotate: 0, opacity: 0.22 }}
            transition={{ duration: 2.2, ease: "easeOut" }}
          >
            <FaPlane className="text-8xl md:text-9xl text-white drop-shadow-2xl" />
          </motion.div>
        </div>

        <div
          onClick={handleRefresh}
          className="absolute top-3 right-3 sm:top-4 sm:right-4 z-20 rounded-lg sm:rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 transition-all duration-200 cursor-pointer"
        >
          <button type="button" className="flex items-center gap-1.5 sm:gap-2 text-white px-2.5 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-medium cursor-pointer">
            <FiRefreshCw className="text-base sm:text-lg shrink-0" />
            <span className="hidden sm:inline">Refresh</span>
          </button>
        </div>

        {/* Main Content */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex-1 flex flex-col justify-center pt-4 pb-6">
          <div className="flex flex-col items-center">
            {/* Heading + subtitle */}
            <motion.div
              className="text-center mb-6 md:mb-8"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <h1 className="text-[38px] sm:text-[48px] md:text-5xl lg:text-6xl font-bold text-white tracking-tight drop-shadow-lg">
                Ready to take off?
              </h1>
              <p className="mt-3 md:mt-4 text-white/90 text-base md:text-lg max-w-md mx-auto font-medium drop-shadow">
                Search flights in one place — domestic & international
              </p>
            </motion.div>

            {/* Search Form */}
            <SearchForm
              formData={formData}
              setFormData={setFormData}
              tripType={tripType}
              setTripType={setTripType}
              airports={airports}
              airportsByServiceType={airportsByServiceType}
              filteredFromAirports={filteredFromAirports}
              setFilteredFromAirports={setFilteredFromAirports}
              filteredToAirports={filteredToAirports}
              setFilteredToAirports={setFilteredToAirports}
              dropdowns={dropdowns}
              setDropdowns={setDropdowns}
              isLoading={isLoading}
              handleSearch={handleSearch}
              handleFromInputChange={handleFromInputChange}
              handleToInputChange={handleToInputChange}
              handleFromFocus={handleFromFocus}
              handleToFocus={handleToFocus}
              toggleDropdown={toggleDropdown}
              selectOption={selectOption}
              swapLocations={swapLocations}
              handleInputChange={handleInputChange}
              getTodayDate={getTodayDate}
              getMinReturnDate={getMinReturnDate}
              travellersRef={travellersRef}
              fromRef={fromRef}
              toRef={toRef}
              serviceRef={serviceRef}
              fareRef={fareRef}
              isLoadingLocations={isLoadingLocations}
              isLoadingFromAirports={isLoadingFromAirports}
              isLoadingToAirports={isLoadingToAirports}
            />
          </div>
        </div>
      </div>

      {waiting && (
        <div
          id="waitingNotification"
          className="flex bg-blue-50 p-2 text-2xl justify-center items-center"
        >
          Please wait for some time because its take some time to fetch the
          flight details...
        </div>
      )}

      {/* Error Display */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mx-4 mt-4 max-w-5xl mx-auto">
          <div className="flex items-center">
            <FaExclamationTriangle className="text-red-500 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-red-700 font-semibold">Search Error</p>
              <p className="text-red-600 text-sm mt-1">{error}</p>
            </div>
            <button
              onClick={() => setError(null)}
              className="ml-4 text-red-500 hover:text-red-700 flex-shrink-0"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Flight Results */}
      <FlightResults
        showResults={showResults}
        setShowResults={setShowResults}
        searchResults={searchResults}
        combinedResults={combinedResults}
        pagedResults={pagedResults}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        handleAuthCheck={handleAuthCheck}
        pageSize={pageSize}
        tripType={tripType}
        expandedFlights={expandedFlights}
        toggleFlightDetails={toggleFlightDetails}
        setSelectedFlightForPrice={setSelectedFlightForPrice}
        setShowPriceModal={setShowPriceModal}
        verifyFlightPrice={verifyFlightPrice}
        fetchSSROptions={fetchSSROptions}
        statusRefdId={statusRefdId}
        onwardRefID={onwardRefID}
        returnRefId={returnRefId}
        formatApiDateTime={formatApiDateTime}
        minutesToHm={minutesToHm}
        getSegments={getSegments}
        getStopsText={getStopsText}
        getTotalDurationMinutes={getTotalDurationMinutes}
        sortBy={sortBy}
        setSortBy={setSortBy}
        filterStops={filterStops}
        setFilterStops={setFilterStops}
        serType={formData.serType}
        totalPaxCount={(formData.adults || 0) + (formData.children || 0) + (formData.infants || 0)}
      />

      {/* Price Modal */}
      <PriceModal
        showPriceModal={showPriceModal}
        setShowPriceModal={setShowPriceModal}
        selectedFlightForPrice={selectedFlightForPrice}
        isLoadingPrices={isLoadingPrices}
        priceOptions={priceOptions}
        handleAuthCheck={handleAuthCheck}
      />

      {/* Passenger Form */}
      <PassengerForm
        showPassengerForm={showPassengerForm}
        setShowPassengerForm={setShowPassengerForm}
        selectedFare={selectedFare}
        formData={formData}
        formPassengerData={formPassengerData}
        setFormPassengerData={setFormPassengerData}
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
        gstInfo={gstInfo}
        setGstInfo={setGstInfo}
        showSeatSelection={showSeatSelection}
        setShowSeatSelection={setShowSeatSelection}
        availableSeats={availableSeats}
        setAvailableSeats={setAvailableSeats}
        selectedSeats={selectedSeats}
        setSelectedSeats={setSelectedSeats}
        isLoadingSeats={isLoadingSeats}
        webCheckinSelected={webCheckinSelected}
        setWebCheckinSelected={setWebCheckinSelected}
        selectedSsr={selectedSsr}
        setSelectedSsr={setSelectedSsr}
        isBooking={isBooking}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        handlePassengerDataChange={handlePassengerDataChange}
        handleDobChange={handleDobChange}
        fetchSeats={fetchSeats}
        selectedFlightForPrice={selectedFlightForPrice}
        setSelectedFlightForPrice={setSelectedFlightForPrice}
        statusRefdId={statusRefdId}
        setIsOpen={setIsOpen}
        handleBooking={handleBooking}
        bookingError={bookingError}
        setBookingError={setBookingError}
        setAmount={setAmount}
        setPriceSummary={setPriceSummary}
        selectedBaggagePerPax={selectedBaggagePerPax}
        setSelectedBaggagePerPax={setSelectedBaggagePerPax}
        selectedMealPerPax={selectedMealPerPax}
        setSelectedMealPerPax={setSelectedMealPerPax}
        ssrItems={ssrItems}
        setSsrItems={setSsrItems}
      />

      <PaymentModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setIsPaying(false);
        }}
        onConfirm={initiateBooking}
        fareData={selectedFlightForPrice}
        isPaying={isPaying}
        setAmount={setAmount}
        setPriceSummary={setPriceSummary}
        serType={formData.serType}
        seatTotal={Object.values(selectedSeats).reduce(
          (sum, seat) => sum + parseInt(seat?.seatAmt || 0),
          0
        )}
        ssrType={selectedSsr?.type || "without"}
        webCheckinSelected={webCheckinSelected}
        userWallet={userWallet}
        totalPayableAmount={totalPayableAmount}
        onWalletPay={handleWalletPayment}
        isWalletProcessing={isWalletProcessing}
        totalPaxCount={Math.max(1, (formData.adults || 0) + (formData.children || 0) + (formData.infants || 0))}
        contactInfo={contactInfo}
        formPassengerData={formPassengerData}
      />

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        setCheckModelLogin={() => setCheckModelLogin(true)}
        setUser={() => setUser(true)}
        onLoginSuccess={() => {
          setShowLoginModal(false);
          if (pendingFareForAuth) {
            setSelectedFare(pendingFareForAuth);
            setGstInfo({ gstNo: "", companyName: "", address: "" });
            setShowPassengerForm(true);
            const hasAddOns = pendingFareForAuth?.selectedBaggage || pendingFareForAuth?.selectedMeal ||
              pendingFareForAuth?.selectedOnwardFare?.selectedBaggage || pendingFareForAuth?.selectedOnwardFare?.selectedMeal;
            setSelectedSsr(hasAddOns ? { type: "with" } : { type: "without" });
            setPendingFareForAuth(null);
          }
        }}
      />

      {/* Booking Success Modal */}
      <BookingSuccessModal
        showBookingSuccess={showBookingSuccess}
        setShowBookingSuccess={setShowBookingSuccess}
        bookingSuccessData={bookingSuccessData}
        selectedFlightForPrice={selectedFlightForPrice}
        contactInfo={contactInfo}
        setShowFeedbackModal={setShowFeedbackModal}
      />

      {/* Feedback Modal */}
      <FeedbackModal
        showFeedbackModal={showFeedbackModal}
        setShowFeedbackModal={setShowFeedbackModal}
        setShowPassengerForm={setShowPassengerForm}
        setShowPriceModal={setShowPriceModal}
        setBookingSuccessData={setBookingSuccessData}
        rating={rating}
        setRating={setRating}
        feedbackText={setFeedbackText}
        setFeedbackText={setFeedbackText}
        isSubmittingFeedback={isSubmittingFeedback}
        handleFeedbackSubmit={handleFeedbackSubmit}
      />

      {/* Update Storage Modal */}
      <UpdateStorageModal
        showUpdateModal={showUpdateModal}
        setShowUpdateModal={setShowUpdateModal}
        handleUpdateStorage={handleUpdateStorage}
      />

      {/* Booking Loader Overlay */}
      {isBooking && (
        <div
          className="fixed inset-0 bg-black/50 flex flex-col items-center justify-center z-[9999]"
          style={{ pointerEvents: "auto" }}
          aria-live="polite"
          aria-busy="true"
        >
          <div className="bg-white rounded-2xl shadow-2xl px-8 py-8 flex flex-col items-center gap-4 min-w-[280px]">
            <FaSpinner className="text-5xl text-blue-600 animate-spin" />
            <p className="text-gray-700 font-medium text-lg">Confirming your booking...</p>
            <p className="text-gray-500 text-sm">Please wait, do not close this window</p>
          </div>
        </div>
      )}

      {/* Sections */}
      <Features />
      <SpecialOffer />
      {/* <Price /> */}
      <About />
      <Services />
      {/* <Testimonials /> */}
      <Faq />
    </div>
  );
};

export default Homepage2;
